import CircleLoader from '../../../../../../../shared/Loaders/CircleLoader'
import TextField from '../../../../../../../shared/Forms/TextField'
import TextInput from '../../../../../../../shared/Inputs/TextInput'
import { IFaqArticleSearchTag } from '../../../../faq.types'
import { ITextInputProps } from '../../../../../../../shared/Inputs/Textarea'
import Modal from '../../../../../../../shared/Modal'
import ModalHeader from '../../../../../../../shared/Modal/ModalHeader'
import Button from '../../../../../../../shared/Buttons/Button/Button'

interface IArticleSearchTagModalContentProps {
  onClose: () => void
  onChange: ITextInputProps['onChange']
  onSave: () => void
  state: Pick<IFaqArticleSearchTag, 'name'>
  loading: boolean
  title: string
}

const ArticleSearchTagModalContent = ({
  title,
  state,
  loading,
  onClose,
  onChange,
  onSave,
}: IArticleSearchTagModalContentProps) => {
  const renderContent = () => {
    if (!state) {
      return (
        <div>
          <CircleLoader />
        </div>
      )
    }

    return (
      <TextField header='Название'>
        <TextInput value={state.name} name='name' onChange={onChange} />
      </TextField>
    )
  }

  return (
    <Modal onClose={onClose} size='sm'>
      <ModalHeader onClose={onClose}>{title}</ModalHeader>
      <div className='modal-content'>{renderContent()}</div>
      <div className='modal-footer'>
        <Button
          theme='primary'
          onClick={onSave}
          disabled={!state.name.trim() || loading}
          loading={loading}
          style={{ width: 'fit-content' }}
        >
          Сохранить
        </Button>
      </div>
    </Modal>
  )
}

export default ArticleSearchTagModalContent
